import { render, staticRenderFns } from "./GameEvents.vue?vue&type=template&id=4312195e&scoped=true"
import script from "./GameEvents.vue?vue&type=script&lang=ts"
export * from "./GameEvents.vue?vue&type=script&lang=ts"
import style0 from "./GameEvents.vue?vue&type=style&index=0&id=4312195e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312195e",
  null
  
)

export default component.exports